import { css } from '@emotion/react';

export const entryLayoutStyles = {
	list: css({
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'start',
		flexWrap: 'wrap',
		rowGap: '1rem',
		columnGap: '2rem',
	}),
	item: css({
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		alignItems: 'start',
		minWidth: '2rem',
		maxWidth: '100%',
	}),
};
